export default __webpack_public_path__ + "static/media/boucherie.2774d45f.webp";